import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 关系方新增
  partiesAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/parties/partiesAdd`,
      method: 'post',
      data,
    });
  },

  // 关系方编辑
  partiesUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/parties/partiesUpdate`,
      method: 'post',
      data,
    });
  },

  // 关系方详情
  partiesDetail(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/parties/partiesDetail?${parameterChange(data)}`,
      method: 'get',
    });
  },

  // 关系方列表
  partiesPageList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/parties/partiesPageList?${parameterChange(data)}`,
      method: 'get',
    });
  },

  // 关系方删除
  partiesDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/parties/partiesDelete`,
      method: 'post',
      data,
    });
  },

  // 关系方下拉列表
  partiesList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/parties/partiesList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },

  // 关系方下拉列表
  partiesList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/parties/partiesList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },

  // 地区列表
  getAreaInfoList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/parties/getAreaInfoList`,
      method: 'get',
      data,
    });
  },
};
